import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import { CODE_VARIANTS } from 'docs/src/modules/constants';
var packagesWithBundledTypes = ['date-fns', '@emotion/react', '@emotion/styled', 'dayjs', 'clsx', '@react-spring/web'];
var muiNpmOrgs = ['@mui', '@base-ui-components', '@pigment-css', '@toolpad'];

/**
 * WARNING: Always uses `latest` typings.
 *
 * Adds dependencies to @types packages only for packages that are not listed
 * in packagesWithBundledTypes
 *
 * @param deps - list of dependency as `name => version`
 */
function addTypeDeps(deps, devDeps) {
  var packagesWithDTPackage = Object.keys(deps).filter(function (name) {
    return !packagesWithBundledTypes.includes(name);
  })
  // All the MUI packages come with bundled types
  .filter(function (name) {
    return !muiNpmOrgs.some(function (org) {
      return name.startsWith(org);
    });
  });
  packagesWithDTPackage.forEach(function (name) {
    var resolvedName = name;
    // scoped package?
    if (name.startsWith('@')) {
      // https://github.com/DefinitelyTyped/DefinitelyTyped#what-about-scoped-packages
      resolvedName = name.slice(1).replace('/', '__');
    }
    devDeps["@types/".concat(resolvedName)] = 'latest';
  });
}
export default function SandboxDependencies(demo, options) {
  var _ref = options || {},
    commitRef = _ref.commitRef,
    _ref$devDeps = _ref.devDeps,
    devDeps = _ref$devDeps === void 0 ? {} : _ref$devDeps;

  /**
   * @param packageName - The name of a package living inside this repository.
   * @return string - A valid version for a dependency entry in a package.json
   */
  function getMuiPackageVersion(packageName) {
    if (commitRef === undefined || process.env.SOURCE_CODE_REPO !== 'https://github.com/mui/material-ui') {
      if (['joy', 'base'].includes(packageName)) {
        return 'latest';
      }
      // #npm-tag-reference
      return 'latest';
    }
    return "https://pkg.pr.new/mui/material-ui/@mui/".concat(packageName, "@").concat(commitRef);
  }
  function extractDependencies() {
    var _demo$relativeModules;
    var muiDocConfig = window.muiDocConfig;
    function includePeerDependencies(deps, versions) {
      var newDeps = _extends({}, deps, {
        'react-dom': versions['react-dom'],
        react: versions.react,
        '@emotion/react': versions['@emotion/react'],
        '@emotion/styled': versions['@emotion/styled']
      });
      if (newDeps['@mui/lab'] || newDeps['@mui/icons-material']) {
        newDeps['@mui/material'] = versions['@mui/material'];
      }
      if (newDeps['@mui/x-data-grid']) {
        newDeps['@mui/material'] = versions['@mui/material'];
      }

      // TODO: consider if this configuration could be injected in a "cleaner" way.
      if (muiDocConfig && muiDocConfig.csbIncludePeerDependencies) {
        newDeps = muiDocConfig.csbIncludePeerDependencies(newDeps, {
          versions: versions
        });
      }
      return newDeps;
    }
    var deps = {};
    var versions = {
      react: 'latest',
      'react-dom': 'latest',
      '@emotion/react': 'latest',
      '@emotion/styled': 'latest',
      '@mui/material': getMuiPackageVersion('material'),
      '@mui/icons-material': getMuiPackageVersion('icons-material'),
      '@mui/lab': getMuiPackageVersion('lab'),
      '@mui/styled-engine': getMuiPackageVersion('styled-engine'),
      '@mui/system': getMuiPackageVersion('system'),
      '@mui/private-theming': getMuiPackageVersion('theming'),
      '@mui/private-classnames': getMuiPackageVersion('classnames'),
      '@mui/base': getMuiPackageVersion('base'),
      '@mui/utils': getMuiPackageVersion('utils'),
      '@mui/material-nextjs': getMuiPackageVersion('material-nextjs'),
      '@mui/joy': getMuiPackageVersion('joy')
    };

    // TODO: consider if this configuration could be injected in a "cleaner" way.
    if (muiDocConfig && muiDocConfig.csbGetVersions) {
      versions = muiDocConfig.csbGetVersions(versions, {
        muiCommitRef: commitRef
      });
    }
    var re = /^import\s'([^']+)'|import\s[\s\S]*?\sfrom\s+'([^']+)/gm;
    var extractImportedDependencies = function extractImportedDependencies(raw) {
      var m = null;
      // eslint-disable-next-line no-cond-assign
      while (m = re.exec(raw)) {
        var _m$;
        var fullName = (_m$ = m[2]) != null ? _m$ : m[1];
        // handle scope names
        var name = fullName.charAt(0) === '@' ? fullName.split('/', 2).join('/') : fullName.split('/', 1)[0];
        if (!deps[name] && !name.startsWith('.')) {
          var _versions$name;
          deps[name] = (_versions$name = versions[name]) != null ? _versions$name : 'latest';
        }
        if (muiDocConfig && muiDocConfig.postProcessImport) {
          var resolvedDep = muiDocConfig.postProcessImport(fullName);
          if (resolvedDep) {
            deps = _extends({}, deps, resolvedDep);
          }
        }
      }
    };
    extractImportedDependencies(demo.raw);
    (_demo$relativeModules = demo.relativeModules) == null || _demo$relativeModules.forEach(function (_ref2) {
      var raw = _ref2.raw;
      return extractImportedDependencies(raw);
    });
    deps = includePeerDependencies(deps, versions);
    return deps;
  }
  var dependencies = extractDependencies();
  if (!demo.productId && !dependencies['@mui/material']) {
    // The `index.js` imports StyledEngineProvider from '@mui/material', so we need to make sure we have it as a dependency
    var name = '@mui/material';
    var versions = _defineProperty({}, name, getMuiPackageVersion('material'));
    dependencies[name] = versions[name] ? versions[name] : 'latest';
  }
  var devDependencies = _extends({}, devDeps);
  if (demo.codeVariant === CODE_VARIANTS.TS) {
    addTypeDeps(dependencies, devDependencies);
    dependencies.typescript = 'latest';
  }
  return {
    dependencies: dependencies,
    devDependencies: devDependencies
  };
}